import React, { useEffect, useState } from 'react';

import { Resources } from '@ariksa/inventory-core';
import { Box, HStack, useDisclosure } from '@chakra-ui/react';
import { each, isEmpty, orderBy, sum } from 'lodash';
import map from 'lodash/map';
import round from 'lodash/round';
import { useSelector } from 'react-redux';
import { customTheme } from 'theme';

import {
  formatNumberWithComma,
  StackedCell,
  WithResourceIcon,
} from 'components/DataDisplay';
import { DashboardTable } from 'components/DataDisplay/NewTable/DashboardTable';
import formatNumber from 'components/DataDisplay/Utils/formatNumber';
import { IconTypes } from 'components/Icons';
import { DashboardWidget } from 'components/Visualization/CDashboard/Widget/DashboardWidget';
import { BarProgress } from 'components/Visualization/Progress/BarProgress';
import { useResourceType } from 'containers/App/hooks/useResourceType';
import { AllEntitiesDrawer } from 'containers/Dashboard/Drawers/AllEntitiesDrawer';
import { selectIdentityOverview } from 'containers/Dashboard/IdentityOverview/selectors';
import { AllEntitiesDetailsProps } from 'containers/Dashboard/types';
import { renderNoEntitiesFoundWithIcon } from 'containers/Dashboard/utils';

export const IdentitiesWithExcessPermissions: React.FC = () => {
  const { identitiesWithExcessPermissions } = useSelector(
    selectIdentityOverview,
  );
  const [data, setData] = useState<Record<string, any>[]>([]);
  const [total, setTotal] = useState(0);
  const { getCloudAgnosticName } = useResourceType();
  const allEntitiesDisclosure = useDisclosure();
  const [details, setDetails] = useState<AllEntitiesDetailsProps>(
    {} as AllEntitiesDetailsProps,
  );

  useEffect(() => {
    let items = {};
    each(
      identitiesWithExcessPermissions.data?.items,
      o => (items[o.provider_or_source_type + ' ' + o.agnostic] = o),
    );
    //setData(items);
  }, [identitiesWithExcessPermissions.data]);

  useEffect(() => {
    let items: Record<string, any>[] = [];
    each(identitiesWithExcessPermissions.data?.items, o => {
      let details: Record<string, any> = {};
      switch (o.agnostic) {
        case Resources.User:
          details = {
            panel: 'excess_privileges_cloud_users',
            iconType: IconTypes.IamUser,
            total: o.count,
          };
          break;
        case Resources.Role:
          details = {
            panel: 'excess_privileges_roles',
            iconType: IconTypes.Role,
            total: o.count,
          };
          break;
        case 'Non-users':
          details = {
            panel: 'excess_privileges_non_users',
            iconType: IconTypes.VirtualMachine,
            total: o.count,
          };
          break;
      }
      items.push({ ...o, details });
    });
    setData(orderBy(items, ['count'], ['desc']));
  }, [identitiesWithExcessPermissions.data]);

  useEffect(() => {
    setTotal(sum(map(data, o => o.count)));
  }, [data]);

  /*const items = [
    {
      label: 'Users',
      count: data?.['Cloud User']?.count || 0,
      percentage: data?.['Cloud User']?.count || 0,
      isLoading: identitiesWithExcessPermissions.isLoading,
      agnostic: IconTypes.User,
      total: 0,
      details: {
        //panel: PanelsEnum.SensitiveDataUsers,
        panel: 'excess_privileges_cloud_users',
        iconType: IconTypes.IamUser,
        total: data?.['Cloud User']?.count || 0,
      },
      iconTooltip: formatTooltip({
        header: 'Users',
        content: 'Cloud-native and federated users',
      }),
    },
    {
      label: 'Roles',
      count: data?.['Cloud Role']?.count || 0,
      percentage: data?.['Cloud Role']?.percentage || 0,
      isLoading: identitiesWithExcessPermissions.isLoading,
      agnostic: IconTypes.Role,
      total: 0,
      details: {
        //panel: PanelsEnum.SensitiveDataUsers,
        panel: 'excess_privileges_roles',
        iconType: IconTypes.IamUser,
        total: data?.['Cloud User']?.count || 0,
      },
      /!*onClick: () => {
        const url = securityGraphRedirectUrl({
          query: getSearchQuery(
            SearchQueryMapping.Show_resource_type_with_excess_permissions,
            ['Role'],
          ),
        });
        navigate(url);
      },*!/
      iconTooltip: formatTooltip({
        header: 'Roles',
        content: 'Cloud-native roles for public clouds, SaaS',
        width: 32,
      }),
    },
    {
      label: 'Non-users',
      count: data?.['Cloud Non-users']?.count || 0,
      percentage: data?.['Cloud Non-users']?.percentage || 0,
      isLoading: identitiesWithExcessPermissions.isLoading,
      agnostic: IconTypes.VirtualMachine,
      total: 0,
      details: {
        //panel: PanelsEnum.SensitiveDataUsers,
        panel: 'excess_privileges_non_users',
        iconType: IconTypes.IamUser,
        total: data?.['Cloud User']?.count || 0,
      },
      /!*onClick: () => {
        const url = securityGraphRedirectUrl({
          query: getSearchQuery(
            SearchQueryMapping.Show_resource_type_with_excess_permissions,
            ['Compute,Credential,ContainerImages,App'],
          ),
        });
        navigate(url);
      },*!/
      iconTooltip: formatTooltip({
        header: 'Non-users',
        content:
          'Non—user identities: VMs, Containers, Container Services, Serverless etc.',
        width: 48,
      }),
    },
    /!*{
      label: 'Group',
      count: data?.['Cloud Group']?.count || 0,
      percentage: data?.['Cloud Group']?.percentage || 0,
      isLoading: identitiesWithExcessPermissions.isLoading,
      agnostic: IconTypes.Group,
      total: 0,
      onClick: () => {
        const url = securityGraphRedirectUrl({
          query: getSearchQuery(
            SearchQueryMapping.Show_resource_type_with_excess_permissions,
            ['Group'],
          ),
        });
        navigate(url);
      },
      /!*iconTooltip: formatTooltip({
        header: 'Group',
        content:
          'Non—user identities: VMs, Containers, Container Services, Serverless etc.',
        width: 48,
      }),*!/
    },*!/
    /!*{
      label: 'Cloud access keys',
      count: 0,
      total: 0,
      //isLoading: identitiesWithExcessPermissions.isLoading,
      iconType: IconTypes.Key,
      /!*onClick: () => {
        const url = securityGraphRedirectUrl({
          query: getSearchQuery(
            SearchQueryMapping.Show_resource_type_with_excess_permissions,
            ['Compute,Credential,ContainerImages,App'],
          ),
        });
        navigate(url);
      },*!/
    },*!/
  ];*/

  const columns = [
    {
      header: (
        <Box pl={10} ml={1}>
          TYPE
        </Box>
      ),
      render: ({ row }) => (
        <WithResourceIcon
          resourceType={
            row?.agnostic === 'Non-users'
              ? IconTypes.VirtualMachine
              : row.agnostic
          }
          color={customTheme.colors.blue['300']}
          useCustomColor
        >
          <StackedCell
            upper={formatNumber(row.count, 1)}
            lower={getCloudAgnosticName(row.agnostic) ?? row.agnostic}
          />
        </WithResourceIcon>
      ),
      styles: { w: '30%' },
      //styles: { cell: { w: '40%' }, header: { w: '40%' } },
    },
    {
      header: 'Accounts',
      render: ({ row }) => row?.accounts?.length ?? 0,
      styles: {
        cell: { textAlign: 'center' },
        header: { textAlign: 'center' },
        w: '20%',
      },
    },
    {
      header: <Box pl="10%">% OF TOTAL</Box>,
      accessor: 'percentage',
      render: ({ value }) => (
        <HStack spacing={3} w="full" pl="10%">
          <Box w={10} textAlign="right">
            {round(value) + '%'}
          </Box>
          <Box w="full">
            <BarProgress
              total={100}
              value={round(value)}
              width="full"
              color="high"
              bg="#9fcc63"
              h="9px"
              showBorder
            />
          </Box>
        </HStack>
      ),
      styles: { w: '50%', header: { textAlign: 'left' } },
    },
  ];

  return (
    <>
      <DashboardWidget
        label="Identities with Excess Permissions"
        subHeader={
          formatNumberWithComma(total) +
          ' identit' +
          (total === 1 ? 'y' : 'ies')
        }
        noData={isEmpty(data)}
        isLoading={identitiesWithExcessPermissions.isLoading}
        noDataMessage={renderNoEntitiesFoundWithIcon('No identities found')}
        content={
          <Box px={2} flex={1} w="full" h="full">
            <DashboardTable
              columns={columns}
              data={data}
              onRowClick={row => {
                if (isEmpty(row?.details)) return;
                allEntitiesDisclosure.onOpen();
                row?.details && setDetails(row.details);
              }}
            />
          </Box>
        }
        styles={{ contentWrapper: { px: 0, pb: 0 } }}
      />
      <AllEntitiesDrawer
        isOpen={allEntitiesDisclosure.isOpen}
        onClose={allEntitiesDisclosure.onClose}
        {...details}
      />
    </>
  );
};
